export default __webpack_public_path__ + "static/media/rooms.6a217ef2.svg";